export const CHANNEL_MIGRATION_DIALOG_SHOW = 'CHANNEL_MIGRATION_DIALOG_SHOW';
export const CHANNEL_MIGRATION_DIALOG_HIDE = 'CHANNEL_MIGRATION_DIALOG_HIDE';

export const FETCH_CHANNEL_MIGRATION_IN_PROGRESS = 'FETCH_CHANNEL_MIGRATION_IN_PROGRESS';
export const FETCH_CHANNEL_MIGRATION_SUCCESS = 'FETCH_CHANNEL_MIGRATION_SUCCESS';
export const FETCH_CHANNEL_MIGRATION_ERROR = 'FETCH_CHANNEL_MIGRATION_ERROR';

export const FETCH_CHANNEL_MIGRATION_STATUS_IN_PROGRESS = 'FETCH_CHANNEL_MIGRATION_STATUS_IN_PROGRESS';
export const FETCH_CHANNEL_MIGRATION_STATUS_SUCCESS = 'FETCH_CHANNEL_MIGRATION_STATUS_SUCCESS';
export const FETCH_CHANNEL_MIGRATION_STATUS_ERROR = 'FETCH_CHANNEL_MIGRATION_STATUS_ERROR';

export const CHANNEL_MIGRATION_AUTHZ_ADDRESS_FETCH_IN_PROGRESS = 'CHANNEL_MIGRATION_AUTHZ_ADDRESS_FETCH_IN_PROGRESS';
export const CHANNEL_MIGRATION_AUTHZ_ADDRESS_FETCH_SUCCESS = 'CHANNEL_MIGRATION_AUTHZ_ADDRESS_FETCH_SUCCESS';
export const CHANNEL_MIGRATION_AUTHZ_ADDRESS_FETCH_ERROR = 'CHANNEL_MIGRATION_AUTHZ_ADDRESS_FETCH_ERROR';

export const FETCH_RETRY_CHANNEL_MIGRATION_IN_PROGRESS = 'FETCH_RETRY_CHANNEL_MIGRATION_IN_PROGRESS';
export const FETCH_RETRY_CHANNEL_MIGRATION_SUCCESS = 'FETCH_RETRY_CHANNEL_MIGRATION_SUCCESS';
export const FETCH_RETRY_CHANNEL_MIGRATION_ERROR = 'FETCH_RETRY_CHANNEL_MIGRATION_ERROR';
